import { defineElements } from '../../src/webflo-runtime/webflo-client/webflo-elements.js';

defineElements();